import React from 'react';

const Vue_Component_Instance_refs = () => {
  return (
    <div>
      <h1>Vue_Component_Instance_refs Component</h1>
      <p>This is the Vue_Component_Instance_refs tutorial page.</p>
    </div>
  );
}

export default Vue_Component_Instance_refs;
